import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Form, Sidebar, Segment } from 'semantic-ui-react';
import activities from 'constants/activities';
import TYPE_NAMES from 'constants/typeNames';
import SidebarHeader from './SidebarHeader';
import ActivityFilter, {
  NON_DEFAULT_ACTIVITIES,
} from './ActivityFilter';
import DefaultFilter from './filters/DefaultFilter';

const CLEAR_KEYS = [
  'search',
  'filter',
  'resource',
  'platform',
  'purpose',
  'provider_name',
  'category',
  'type',
  'status',
  'group_type',
];

const SIDEBAR_CLASS_MAP = {
  [activities.GROUP_TRANSACTIONS]: 'sidefilter',
  [activities.SETTING_FEATURES]: 'resized',
};

const SidebarFilter = ({
  filterOn,
  setFilterOn,
  form,
  setForm,
  filterTransactions,
  handleChange,
  types,
  category,
  typeName,
  searchName,
  activity,
  resourceId,
  group,
}) => {
  const [clear, setClear] = useState(false);
  const { pathname } = useLocation();
  const { push } = useHistory();

  const handleClear = () => {
    const reset = CLEAR_KEYS.reduce((acc, key) => {
      if (key in form) acc[key] = null;
      return acc;
    }, {});
    setForm(reset);
    setClear(true);
    push(pathname);
  };

  useEffect(() => {
    if (clear) setClear(false);
  }, [clear]);

  if (clear) return <></>;

  const sidebarClass = SIDEBAR_CLASS_MAP[activity] || 'modified';
  const isDefaultActivity = !NON_DEFAULT_ACTIVITIES.includes(
    activity,
  );

  return (
    <Sidebar
      className={sidebarClass}
      as={Segment}
      direction="right"
      animation="overlay"
      visible={filterOn}
      width="wide"
    >
      <SidebarHeader
        onBack={() => setFilterOn(false)}
        onClear={handleClear}
      />
      <div className="padding">
        <Form onSubmit={filterTransactions}>
          <ActivityFilter
            activity={activity}
            category={category}
            form={form}
            handleChange={handleChange}
            resourceId={resourceId}
            group={group}
            types={types}
            typeName={typeName}
          />
          {isDefaultActivity && (
            <DefaultFilter
              activity={activity}
              category={category}
              form={form}
              handleChange={handleChange}
              searchName={searchName}
              types={types}
              typeName={typeName}
            />
          )}
        </Form>
      </div>
    </Sidebar>
  );
};

SidebarFilter.defaultProps = {
  searchName: 'Name',
  typeName: TYPE_NAMES.TYPE,
  activity: null,
  resourceId: null,
  group: {},
};

SidebarFilter.propTypes = {
  filterOn: PropTypes.bool.isRequired,
  setFilterOn: PropTypes.func.isRequired,
  form: PropTypes.instanceOf(Object).isRequired,
  group: PropTypes.instanceOf(Object),
  setForm: PropTypes.func.isRequired,
  filterTransactions: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  types: PropTypes.instanceOf(Object).isRequired,
  category: PropTypes.string.isRequired,
  searchName: PropTypes.string,
  typeName: PropTypes.string,
  activity: PropTypes.string,
  resourceId: PropTypes.string,
};

export default SidebarFilter;
